import React from 'react'
import { format } from 'date-fns'
import { Model } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
export const FormattedUserName: React.SFC<{ user: Model.User }> = (props) => (
  <>{props.user.username || props.user.email}</>
)
